import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import UtilService from '../../../helper/service';
import { useHistory } from "react-router";
import { getSessionParticipantsSuccess, initLiveAnalysisData } from '../../../store/actions/creator/creatorExperienceManager';
import { SESSION_SMALL_THUMBNAIL } from '../../../config/mock';
import { initAnalysisData, updateClipedData } from "../../../store/actions/creator/analysis";
import roles from "../../../helper/roles";
import apiConfigs from '../../../config/config';
import { useCallback } from "react";
import useWindowSize from "../../../helper/hooks/useWindowSize";

const useStyles = makeStyles(() => ({
  tr: {
    height: 80,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: 'Spartan-Bold',
    color: '#8192A2',
    fontSize: 14,
    cursor: 'pointer',
    borderBottom: '1px solid #F5F5F5',
    '& div': {
      textAlign: 'center'
    },
  },
  icon: {
    borderRadius: 3,
    width: 18,
    height: 18,
    backgroundColor: '#f5f8fa',
    backgroundImage: "url(\"/assets/icons/dashboard/uncheckbox.svg\")",
  },
  checkedIcon: {
    '&:before': {
      display: 'block',
      width: 21,
      height: 18,
      backgroundImage: "url(\"/assets/icons/dashboard/checkbox.svg\")",
      content: '""',
    },
  },
  left: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'roboto',
  },
  imgDiamond: {
    width: 11,
    height: 11,
  },
  img: {
    width: 120,
    height: 72,
    borderRadius: 10,
    marginRight: 25,
    objectFit: 'cover'
  },
  pt5: {
    paddingTop: 5
  },
  healthyText: {
    color: '#1DB859',
    fontFamily: 'Spartan-Bold',
    fontWeight: 700,
    fontSize: 14
  },
  healthyBg: {
    backgroundColor: '#1DB85914',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  safetyDiv: {
    fontFamily: 'Spartan-Bold',
    fontWeight: 700,
    fontSize: '17px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  green: {
    color: '#1DB859',
    backgroundColor: '#1DB85914'
  },
  gray: {
    color: '#8192A2',
    backgroundColor: '#8192A214'
  },
  red: {
    color: '#ED564A',
    backgroundColor: '#ED564A14'
  },
  grayBg: {
    backgroundColor: '#8192A214',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },

  textKey: {
    fontSize: '17px !important',
    fontWeight: 700,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },

  dangerText: {
    color: '#ED564A',
    fontFamily: 'Spartan-Bold',
    fontWeight: 700,
    fontSize: 14
  },
  dangerBg: {
    backgroundColor: '#ED564A14',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },

  textPercentage: {
    color: '#606B76',
    fontFamily: 'roboto-regular',
    fontSize: 13,
  },

  textNorm: {
    fontFamily: 'roboto-bold',
    fontSize: 12,
    color: '#017AEF',
  },
  textAverage: {
    fontFamily: 'roboto-bold',
    fontSize: 12,
    color: '#697683',
  },
  textBench: {
    fontFamily: 'roboto-bold',
    fontSize: 12,
    color: '#F7B926',
  },
  trNorm: {
    height: 32,
    background: '#017AEF14',
  },

  trNormDash: {
    height: 32,
    background: '#017AEF14',
  },

  m8: {
    // margin: '0 8px'
  },
  clips: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer'
    },
    '& div': {
      fontFamily: 'roboto-regular',
      fontSize: 14,
      marginRight: 8
    },
  },

  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  itemTextFrom: {
    fontFamily: 'roboto-regular',
    marginTop: 2,
    marginRight: 4,
    fontSize: 10,
  },

  itemTextClip: {
    fontFamily: 'roboto-bold',
    margin: 0,
    fontSize: 14,
    color: '#000',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    wordWrap: 'break-word',
    maxHeight: 35,
    marginLeft: 4,
    // width: '100%',
    overflow: 'hidden',
  },

  opened: {
    marginTop: '22px!important',
  },
  muted: {
    color: '#017AEF'
  },
  rotate: {
    transform: 'rotate(90deg)',
  },
  separator: {
    background: '#D9D9D9',
    height: '102%',
  },
  imgDiv: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  mp3Icon: {
    width: '38px',
    height: '38px',
    position: 'absolute',
    textAlign: 'center',
    marginLeft: '-33px',
  },
  borderCorner: {
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10
  }
}));

export function CompareTableBody(props: any) {

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { width } = useWindowSize();
  const { item, HEADER, wiseHeader, open, category, showSafety, final } = props;
  const { currentSession, cliped } = useSelector((state: any) => state.analysis);
  const { sortImmersion } = useSelector((state: any) => state.compare);
  const { session_code, session_type, session_length } = currentSession;

  const TAGS = wiseHeader.filter((x: any) => x.category === (sortImmersion ? 'immersion' : 'safety')).map((pp: any) => UtilService.compareText2(pp.title))

  const goManagerParticipantPage = () => {
    isClipped(item) ? onGoAnalysisClip() : onGoManagerParticipantPage();
  };

  const onGoManagerParticipantPage = () => {
    dispatch(initAnalysisData());
    dispatch(initLiveAnalysisData());
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    if (!item.session_code) return;
    if (item.session_code === 'industry_norm') return;
    dispatch(getSessionParticipantsSuccess(null));
    localStorage.setItem("session_code", String(item.session_code));
    localStorage.setItem("session_id", String(item.session_id));
    localStorage.setItem("session_name", String(item.name));

    let routertabname = 'participants';
    switch (item.status.toLowerCase()) {
      case "upcoming":
        routertabname = "participants";
        break;
      case "completed":
        routertabname = "overview";
        break;
      case "live":
        routertabname = "analyze";
        break;
      case "compare":
        routertabname = "compare";
        break;
      default:
        break;
    }
    // if (item.status.toLowerCase() !== "upcoming") {
    //   const request = {
    //     session_code: item.session_code,
    //   }
    //   dispatch(getSessionParticipants(apolloClient.client, request));
    // }
    let url = `/creator/experience-manager/${routertabname}/${item.session_code}`;
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
        url = `/subscriber/creator/experience-manager/${routertabname}/${item.session_code}`;
      }
    }
    history.push(url, { session_id: item.session_id });
  };

  const onGoAnalysisClip = () => {
    dispatch(initAnalysisData());
    dispatch(initLiveAnalysisData());
    dispatch(getSessionParticipantsSuccess(null));
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    localStorage.setItem("session_code", String(item.session_code));
    localStorage.setItem("session_id", String(item.session_id));
    localStorage.setItem("session_name", String(item.name));

    let url = `/creator/experience-manager/analyze/${item.session_code}`;
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
        url = `/subscriber/creator/experience-manager/analyze/${item.session_code}`;
      }
    }
    history.push(url, { session_id: item.session_id });

    setTimeout(() => {

      dispatch(updateClipedData({
        title: item.name,
        start_clip: item.session_type === 'ASYNC' ? UtilService.getTimeInputLabel(item.start, false) / 15 : item.start,
        end_clip: item.session_type === 'ASYNC' ? UtilService.getTimeInputLabel(item.end, true) / 15 : item.end,
        clip_id: item.clip_id,
        session_code: item.session_code,
        score: {
          immersion: {
            immersion_index: item.immersion,
            tier_indicator: item.immersion_tier_indicator,
            color_indicator: item.immersion_color_indicator,
            context_indicator: item.immersion_context_indicator,
          },
          safety: {
            safety_index: item.safety,
            tier_indicator: item.safety_tier_indicator,
            color_indicator: item.safety_color_indicator,
            context_indicator: item.safety_context_indicator,
          }
        }
      }))
    }, 2000);

  };


  const isClipped = (session: any) => {
    if (!session) return false;

    return (String(session.session_id).includes('clip-'));
  };

  const getDetailValue = (value: number, key: any) => {
    const percentTags = ['Captivated', 'Absorbed', 'Interested', 'Indifferent', 'Tuned Out', 'Zen', 'Very Safe', 'Safe', 'Unsafe', 'Very Unsafe']
    return value > 0 ? `${value !== Math.floor(value) ? value.toFixed(1) : value}${percentTags.includes(key) ? '%' : ''}` : '-';
  };

  const getImmersionDetailValue = (item: any, key: string) => {
    if (item && item.immersion_detail && item.immersion_detail[key]) return getDetailValue(Number(item.immersion_detail[key]), key);
    return '-';
  };

  const getSafetyDetailValue = (item: any, key: string) => {
    if (item && item.safety_detail && item.safety_detail[key]) return getDetailValue(Number(item.safety_detail[key]), key);
    return '-';
  };

  const getItemName = (session: any) => {
    if (!session) return;

    if (isClipped(session)) {
      return session.session_title;
    } else {
      return session.name;
    }
  };

  const checkPrimary = (item: any) => {
    return (session_code === String(item.session_code)) && item.session_code !== 'industry_norm';
  };

  const onShowSafety = useCallback(() => {
    const length = cliped ? Number(cliped.end_clip - cliped.start_clip) : Number(session_length);
    return UtilService.isShowSafety(session_type, length);
  }, [session_type, session_length, cliped]);

  const getSafetyClass = useCallback(() => {
    if (item.safety && item.session_code !== 'industry_norm') {
      switch (UtilService.getColorFromSessionWithCategory(item, "safety")) {
        case 'green':
          return classes.green;
        case 'gray':
          return classes.gray;
        case 'red':
          return classes.red;
        default:
          return classes.gray;
      }
    }
  }, [item, classes]);

  return (
    <div
      className={clsx(
        classes.tr,
        classes.m8,
        (item && ('session_id' in item) && item.session_id === open && classes.opened),
        final && classes.borderCorner)
      }
      style={(item && ('session_code' in item) && (item.session_code === 'industry_norm')) ? {
        height: 32,
        background: item.name === 'Industry Average' ? '#017AEF14' : item.name === 'My Average' ? '#f3f4f5' : item.name === 'My Benchmark' ? '#fefaee' : '',
      } : {}
      }
    >
      <div style={{ width: HEADER[0].width }}>
        {checkPrimary(item) &&
          <img className={clsx(classes.imgDiamond, 'safari-backface')} src={'/assets/icons/compare/icon_diamond.svg'} alt={'img'} />
        }
      </div>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}
        className={clsx(classes.left,
          (item.name === 'Industry Average') && classes.textNorm,
          (item.name === 'My Average') && classes.textAverage,
          (item.name === 'My Benchmark') && classes.textBench
        )
        }
        onClick={() => item?.session_code !== 'industry_norm' && goManagerParticipantPage()}>

        {item.session_code !== 'industry_norm' &&
          <div className={classes.imgDiv}>
            <img
              src={isClipped(item) ? (`${apiConfigs.S3_IMG_URL}/large-${typeof item.immersion === 'number' ? (item.immersion % 70 + 1) : 64}.svg`) : (item.img_large ? item.img_large : SESSION_SMALL_THUMBNAIL)}
              alt={'img'}
              className={clsx(classes.img, 'safari-backface')}
            // onError={e => e.currentTarget.src = SESSION_SMALL_THUMBNAIL}
            />
            {(item.stimulus_type === 'AUDIO') && (
              <img
                src={`/assets/icons/mp3.svg`}
                alt={'img'}
                className={clsx(classes.mp3Icon, 'safari-backface')}
                onError={e => e.currentTarget.src = '/assets/images/video-processing.png'}
              />
            )}
          </div>

        }

        {
          (item.name === 'Industry Average') &&
          <img
            alt={'img'}
            src={'/assets/icons/compare/icon_briefcase.svg'}
            style={{ marginLeft: -8, marginRight: 8 }}
          />
        }

        {
          (item.name === 'My Average') &&
          <img
            alt={'img'}
            src={'/assets/icons/share-icon.svg'}
            style={{ marginLeft: -8, marginRight: 8 }}
          />
        }

        {
          (item.name === 'My Benchmark') &&
          <img
            alt={'img'}
            src={'/assets/icons/overview/benchmark_3.svg'}
            style={{ marginLeft: -8, marginRight: 8 }}
          />
        }

        <div>

          {isClipped(item) &&
            <div className={classes.row}>
              <img src={'/assets/icons/dashboard/scissors.svg'} alt='{img}' className={clsx('safari-backface')} style={{ marginLeft: 4 }} />
              <p className={clsx(classes.itemTextClip, 'line-clamp-1')}>
                {item.name}
              </p>
            </div>
          }

          <div className={classes.row} style={{ marginTop: 4 }}>

            {isClipped(item) &&
              <span className={classes.itemTextFrom}> from </span>
            }

            <span className={clsx('line-clamp-1')}>
              {getItemName(item)}
            </span>
          </div>

        </div>

      </div>

      <div
        style={{
          width: width <= 1025 ? HEADER[2].mobileWidth : HEADER[2].width,
          color: (item.name === 'Industry Average') ? '#017AEF' : (item.name === 'My Benchmark') ? '#F7B926' : ''
        }}
        className={clsx(UtilService.getColorFromSessionWithCategory(item, 'immersion') === 'green' && classes.healthyText,
          (item.immersion && item.session_code !== 'industry_norm') && UtilService.getColorFromSessionWithCategory(item, 'immersion') === 'green' && category === 'immersion' && classes.healthyBg,
          (item.immersion && item.session_code !== 'industry_norm') && UtilService.getColorFromSessionWithCategory(item, 'immersion') === 'red' && classes.dangerText,
          (item.immersion && item.session_code !== 'industry_norm') && UtilService.getColorFromSessionWithCategory(item, 'immersion') === 'red' && category === 'immersion' && classes.dangerBg,
          (item.immersion && item.session_code !== 'industry_norm') && UtilService.getColorFromSessionWithCategory(item, 'immersion') === 'gray' && category === 'immersion' && classes.grayBg,
          classes.textKey)}
        onClick={() => item?.session_code !== 'industry_norm' && goManagerParticipantPage()}
      >
        <span className={classes.pt5}>
          {(item.immersion && item.immersion) ? (String(item.immersion) === '0' || String(item.immersion) === '1' ? '-' : item.immersion) : '-'}
        </span>

      </div>

      {
        category === 'immersion' && (
          <>
            {TAGS.map((c: any, kk: number) => <div key={kk}
              style={{ width: width <= 1025 ? 80 : 110 }}
              className={clsx((item.immersion && item.session_code !== 'industry_norm') && classes.textPercentage)}
            >
              {getImmersionDetailValue(item, c)}
            </div>)}

          </>
        )
      }

      {(showSafety === true && onShowSafety()) &&
        <div
          style={{ width: HEADER[8].width }}
          className={clsx(classes.separator)}
          onClick={() => item?.session_code !== 'industry_norm' && goManagerParticipantPage()}
        >
        </div>
      }

      {(showSafety === true && onShowSafety()) &&
        <div
          style={{
            width: width <= 1025 ? HEADER[9].mobileWidth : HEADER[9].width,
            color: (item.name === 'Industry Average') ? '#017AEF' : (item.name === 'My Benchmark') ? '#F7B926' : ''
          }}
          className={clsx(classes.safetyDiv, getSafetyClass())}
          onClick={() => item?.session_code !== 'industry_norm' && goManagerParticipantPage()}
        >
          <span className={classes.pt5}>
            {(item.safety && item.safety) ? ((String(item.safety) === '0' || String(item.safety) === '1') ? '-' : item.safety) : '-'}
          </span>
        </div>
      }

      {
        (category === 'safety' && showSafety === true && onShowSafety()) && (
          <>
            {TAGS.map((c: any, kk: number) => <div key={kk}
              style={{ width: width <= 1025 ? 80 : 110 }}
              className={clsx((item.immersion && item.session_code !== 'industry_norm') && classes.textPercentage)}>
              {getSafetyDetailValue(item, c)}
            </div>)}
          </>)
      }
    </div>
  )
}